import React from 'react';

type ResultLoadingStateProps = {
    title?: string;
    description?: string;
};

const ResultLoadingState: React.FC<ResultLoadingStateProps> = ({
    title = 'Loading Result...',
    description = 'Please wait while we load your test result.',
}) => {
    return (
        <div className="flex items-center justify-center min-h-96">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-mld-primary mx-auto mb-4"></div>
                <h2 className="text-xl font-semibold text-mld-text-primary mb-2">{title}</h2>
                <p className="text-gray-600">{description}</p>
            </div>
        </div>
    );
};

export default ResultLoadingState;

